import { render, staticRenderFns } from "./QuotaView.vue?vue&type=template&id=01c225f9&scoped=true"
import script from "./QuotaView.vue?vue&type=script&lang=js"
export * from "./QuotaView.vue?vue&type=script&lang=js"
import style0 from "./QuotaView.vue?vue&type=style&index=0&id=01c225f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c225f9",
  null
  
)

export default component.exports